<sm-title-bar
  pageTitle="Promotion"
  [headerCustomTemplate]="addButton"
  [backWithParams]="true"
>
  <ng-template #addButton>
    <div class="d-flex search-field">
      <!-- <div class="create_btn_sd">
        <button mat-button color="accent" (click)="opencreatenew()">
          <mat-icon>add</mat-icon>
          Create new
        </button>
      </div> -->
      
      <div class="create_btn_sd">
        <button mat-flat-button aria-label="option menu" color="accent" (click)="opencreatenew()">
            <mat-icon>add</mat-icon> 
            Add new
        </button>
    </div>
<!-- 
      <mat-menu #menu="matMenu" style="width: 160px;">
        <button  mat-menu-item >
          <mat-icon class="material-icons-outlined">family_restroom</mat-icon>
          <span>Customers</span>
        </button>
        <button  mat-menu-item>
          <mat-icon class="material-icons-outlined"> diversity_3</mat-icon>
          <span>Members</span>
        </button>
      </mat-menu> -->


    </div>
  </ng-template>
</sm-title-bar>

<div class="row row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 g-4" *ngIf="!loader && campaignData.length > 0">
  <div class="col" *ngFor="let item of campaignData">
    <mat-card class="admin-post-card overflow-hidden">
        <div class="placeholder_heading_tr" *ngIf="!item.media_thumb_url || item.media_thumb_url =='null' " >
           <h3>{{item.title.slice(0,1).toUpperCase()}}</h3>
        </div>

      <div class="card-carousel" *ngIf="item.media_thumb_url && item.media_thumb_url !='null' ">
        <img [src]="item.media_thumb_url" onerror="this.src='../../../../assets/images/photo.png'" alt="Post Image" style=" width: 100% !important; object-fit: cover; object-position: center; border-radius: 10px;
    margin-bottom: 15px;" />
      </div>

       <mat-card-content>
          <button class="ms-auto option-btn" mat-icon-button aria-label="option menu" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
             <button mat-menu-item (click)="openshowtarget(item)"> 
            <mat-icon class="material-icons-outlined">groups</mat-icon>
            <span>Show targets</span>
          </button>
          <button mat-menu-item (click)="deleteItem(item)">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
        <h3 style="font-weight: bold !important; margin-bottom: 3px; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; white-space: normal;" [matTooltip]="item.title">
         {{item.title}}


        </h3>

        <!-- <p class="description_ssd" [matTooltip]="item.body" >
          {{item.body && item.body.length>=80 ? (item.toshowmore==true?item.body.substring(0,80) + '...' :item.body) : item.body}}
          <span *ngIf="item.body && item.body.length>=80" (click)="showmore(item)" class="show_tty">{{item.toshowmore == true? 'show more' : 'show less'}}</span>
        </p> -->
        
        <p class="description_ssd" [matTooltip]="item.body" style="font-weight: normal !important; margin-bottom: 3px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; white-space: normal;">
          {{item.body}}
          
        </p> 
        <!-- *ngIf="item.external_link && item.external_link != 'null' && item.external_link != ''" -->
        <p class="exter_link" [matTooltip]="item.external_link" > <span > External link: </span> <a href="javascript:void(0)" (click)="openlink(item)" class="list_link" [ngStyle]="{'text-decoration' :item.external_link && item.external_link != '' && item.external_link != 'null'? 'underline': 'none' }"> {{item.external_link && item.external_link != '' && item.external_link != 'null'? item.external_link : '---' }} </a></p>
        <div class="campaing_date">
          <p><span >Campaign start:</span> {{item.campaign_start_date | date}} </p>
          <p><span >Campaign end:</span> {{item.campaign_end_date | date}} </p>
          <p><span >Campaign cost:</span> {{item?.currency_symbol}}{{item.campaign_cost.toFixed(2)}} </p>
        </div>
        <div class="date_ttu">
          <div class="adad">
            <p>Created on: {{item.creationt_time | date}}</p>
             </div>
            <div style="display: flex;align-items: center;position:relative;top: -5px;">
              <span class="status_circle" [class.new]="item.campaign_progress == 0" [class.in-progress]="item.campaign_progress == 1" [class.complete]="item.campaign_progress == 2" [class.paused]="item.campaign_progress == 3"></span> <span style="margin-left: 5px;" [class.new-t]="item.campaign_progress == 0" [class.in-progress-t]="item.campaign_progress == 1" [class.complete-t]="item.campaign_progress == 2" [class.paused-t]="item.campaign_progress == 3">{{item.c_progress}}</span>

           
            </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

 <div class="placeholder_started" *ngIf="!loader && campaignData.length == 0">
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card>
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/flat-camp.jpg" />
            </div>
            <mat-card-title>No campaign to show</mat-card-title>
            <mat-card-content>
             So far no WhatsApp broadcast campaign or promotions created. Retain customers, promote business, greet or send offer.    
            </mat-card-content>
              <div class="watch_vc_btn">
              <button (click)="opencreatenew()" mat-stroked-button color="primary"  mat-button aria-label="option menu">
                <mat-icon>add</mat-icon> 
               Add new
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card>
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png" />
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content>
             For any difficulties in creating a campaign or if there's any issue in getting the old campaigns, contact our support team.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary">
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div> 
